import config from "../Config";
import { authFetch } from "./authFetch";

/**
 * Stream a log endpoint to a .log file on disk.
 *
 * Log bodies are stored outside the database and the read endpoints only return
 * the tail of a large one, so the full text has to be streamed from the API rather
 * than rebuilt from what is on screen. Throws with a user-facing message on failure.
 */
async function saveLogAs(url, filename) {
  const res = await authFetch(url);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || "Could not download the log.");
  }
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}

/** Download the complete log for a job or cron run. */
export async function downloadJobLog(jobId) {
  await saveLogAs(
    `${config.RUNNER_API}/v1/download-log?job_id=${encodeURIComponent(jobId)}`,
    `${jobId}.log`
  );
}

/** Download the complete log for an image build. */
export async function downloadBuildLog(buildId) {
  await saveLogAs(
    `${config.RUNNER_API}/v1/cdci/build-log/${encodeURIComponent(buildId)}/download`,
    `${buildId}.log`
  );
}

export function formatLogSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
